import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { isNativeApp } from '../utils/platform';
import './SignupSelect.css';

const SignupSelect = () => {
  const navigate = useNavigate();
  const isNative = isNativeApp();

  // On native iOS/Android apps, only show athlete signup (no coach/payment options)
  if (isNative) {
    return (
      <div className="signup-select-page">
        <nav className="signup-nav">
          <Link to="/" className="nav-logo">Three Plates</Link>
        </nav>

        <div className="signup-select-content">
          <h1>Athlete Sign Up</h1>
          <p className="subtitle">Join your team to access workouts</p>

          <div className="program-cards single-card">
            <div className="program-card" onClick={() => navigate('/signup/athlete')}>
              <div className="card-icon">💪</div>
              <h2>Join Your Team</h2>
              <p className="card-subtitle">For Athletes</p>
              <p className="card-description">
                Sign up with your team's access code to view and log workouts assigned by your coach.
              </p>
              <span className="card-link">Get Started →</span>
            </div>
          </div>

        </div>
      </div>
    );
  }

  return (
    <div className="signup-select-page">
      <nav className="signup-nav">
        <Link to="/" className="nav-logo">Three Plates</Link>
      </nav>

      <div className="signup-select-content">
        <h1>Choose Your Program</h1>
        <p className="subtitle">Select the option that best fits your needs</p>

        <div className="program-cards two-cards">
          <div className="program-card" onClick={() => navigate('/signup/team')}>
            <div className="card-icon">🏫</div>
            <h2>Teams & Schools</h2>
            <p className="card-subtitle">For Universities, Colleges, and High Schools</p>
            <p className="card-description">
              Manage entire athletic programs with team-based workout assignments. Perfect for coaches overseeing multiple athletes.
            </p>
            <span className="card-link">Get Started →</span>
          </div>

          <div className="program-card" onClick={() => navigate('/signup/athlete')}>
            <div className="card-icon">💪</div>
            <h2>Join Your Team</h2>
            <p className="card-subtitle">For Athletes</p>
            <p className="card-description">
              Sign up with your team's access code to view and log workouts assigned by your coach.
            </p>
            <span className="card-link">Get Started →</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupSelect;
